import {CLEAR_APP_STATE, CLEAR_ORDER_WIZARD, CLEAR_STATE, SAVE_RESTAURANT_CATEGORIES} from "../../actions/types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SAVE_RESTAURANT_CATEGORIES:
            return action.payload;
        case CLEAR_ORDER_WIZARD:
            if (action.fromPwa) {
                return state;
            } else {
                return INITIAL_STATE;
            }
        case CLEAR_STATE:
            // if (action.fromPwa) {
            //     return state;
            // } else {
                return INITIAL_STATE;
            // }
        case CLEAR_APP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}
